import { render, staticRenderFns } from "./NoticeLayout.vue?vue&type=template&id=9f49972e&scoped=true"
import script from "./NoticeLayout.vue?vue&type=script&lang=js"
export * from "./NoticeLayout.vue?vue&type=script&lang=js"
import style0 from "./NoticeLayout.vue?vue&type=style&index=0&id=9f49972e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f49972e",
  null
  
)

export default component.exports